module.exports = __webpack_public_path__ + "static/media/edhhah.d1c71700.jpg";